import { render, staticRenderFns } from "./CatalogOrder.vue?vue&type=template&id=f8e41f42&"
import script from "./CatalogOrder.vue?vue&type=script&lang=ts&"
export * from "./CatalogOrder.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports